import { axiosInstance } from "../../../Services";

export const getInventoryProjects = async (inventoryId) => {
  try {
    const res = await axiosInstance.get(
      `/rsform/inventories/${inventoryId}/projects`,
    );
    return res;
  } catch (err) {
    throw err;
  }
};
